import { searchApiService } from '@search/services';
import { authQuery } from '../config/query.config';

export const searchApi = searchApiService(authQuery);

export const { useSearchContentAndCommunityQuery, useLazySearchContentAndCommunityQuery } =
  searchApi;
